// ----
// Close Instructions modal
// ----

attachEvent('.modal__close, .modal__overlay', 'click', (ev) => {
  ev.target.closest('.modal').classList.remove('is-open-modal');
});
